import { Locale } from '@/providers/Locale/types'

type TextFields = 'signupHeading' | 'ctaText' | 'signupDescription' | 'inputPlaceholder' | 'successSubtitle'

export const i18n: Record<Locale, Record<TextFields, string>> = {
    en: {
        signupHeading: 'Sign up for the Daily Brief',
        signupDescription: 'Our free, fast and fun briefing on the global economy, delivered every weekday morning.',
        ctaText: 'Sign me up',
        inputPlaceholder: 'Enter email address',
        successSubtitle: 'Your inbox just got better.',
    },
    es: {
        signupHeading: 'Suscríbete al resumen diario',
        signupDescription: 'Nuestro informe gratuito, rápido y divertido sobre la economía mundial, entregado todas las mañanas de los días laborables.',
        ctaText: 'Regístrate',
        inputPlaceholder: 'Introduzca la dirección de correo electrónico',
        successSubtitle: 'Tu bandeja de entrada acaba de mejorar.',
    },
    fr: {
        signupHeading: 'Inscrivez-vous au briefing quotidien',
        signupDescription: "Notre briefing gratuit, rapide et amusant sur l'économie mondiale, diffusé chaque matin en semaine.",
        ctaText: 'Inscrivez-moi',
        inputPlaceholder: "Entrez l'adresse e-mail",
        successSubtitle: "Votre boîte de réception vient de s'améliorer.",
    },
    de: {
        signupHeading: 'Melden Sie sich für den täglichen Newsletter an',
        signupDescription: 'Unser kostenloses, schnelles und unterhaltsames Briefing zur Weltwirtschaft wird jeden Wochentagmorgen geliefert.',
        ctaText: 'Melde mich an',
        inputPlaceholder: 'Geben Sie die E-Mail-Adresse ein',
        successSubtitle: 'Ihr Posteingang hat sich gerade verbessert.',
    },
}
